angular.module('clients')
    .component('clientAddressSection', {
        bindings: {
            client: '<'
        },
        template: `
            <div class="task-detail-label" ng-if="$ctrl.client != null"><i class="fa fa-industry fa-lg"></i></div>
            <div class="task-detail-value" ng-if="$ctrl.client != null">
                <div>
                    <a href="#/clients/{{$ctrl.client.id}}" class="bold">{{$ctrl.client.symbol}}</a>
                </div>
                <div>
                    <div class="bold" style="color: green;">{{$ctrl.client.fullName}}</div>
                    <div>{{$ctrl.client.fullAddress}}</div>
                </div>
            </div>
        `
    })
